import React from "react";
import { Button } from "nr1";

const StorePaginationControls = ({ currentPage, setCurrentPage, totalPages, t }) => (
  <div className="pagination-controls">
    <Button disabled={currentPage === 1} onClick={() => setCurrentPage(1)} title="First page">&#x00AB; {t('first')}</Button>
    <Button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)} title="Previous page">&#x2190; {t('prev')}</Button>
    <span className="page-indicator">{t('page')} {currentPage} {t('of')} {totalPages}</span>
    <Button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)} title="Next page">{t('next')} &#x2192;</Button>
    <Button disabled={currentPage === totalPages} onClick={() => setCurrentPage(totalPages)} title="Last page">{t('last')} &#x00BB;</Button>
  </div>
);

export default StorePaginationControls;